import { Box, Grid, Typography, Container, Stack } from "@mui/material";

import dashboardBackground1 from "../../images/steminpe-dashboard-bg.png";
import { useState } from "react";

import DisplayHeader from "./SteminpeDisplayHeader";
import LeaderboardItem from "./SteminpeLeaderboardItem";

const MAIN_FONT = "Noto Sans TC";

const BackgroundMap = {
  blue: dashboardBackground1,
  orange: dashboardBackground1,
  purple: dashboardBackground1,
  green: dashboardBackground1,
};


export default function Component({ leaderboardData, leaderboardInfo, themeData, isLoading=false }) {
  

  const NothingDisplay = () => {
    return (
      <Box
        sx={{
          border: "0px solid #eee",
          borderRadius: "10px",
          // boxShadow: " 0 3px 10px  #9ecaed;",
        }}
        my={4}
      >
        <Grid
          container
          justifyContent="center"
          alignItems={"center"}
          py={4}
          px={4}
        >
          <Grid item xs={12}>
            <Typography variant="h2" color={"black"}>
              未有資料
            </Typography>
          </Grid>
        </Grid>
      </Box>
    );
  };


  if(themeData == null){
    themeData = {};
  }

  const isLoaded = leaderboardData == null ? false : true;

  const bgColor = themeData.bg || "blue"
  const barColor = themeData.barColor || "red"

  // const getBarDataList = () => {
  //   return leaderboardData.map((data, index) => {
  //     console.debug("data", data)
  //     return {
  //       rank: data.rank,
  //       schoolName: data.organization_name_zh,
  //       score: Math.round(data.score),
  //     }
  //   })
  // }

  const calculateBestScore = (dataList) => {
    let bestScore = 1
    for (let data of dataList) {
      let newScore = Math.round(data.score)
      if (newScore > bestScore) {
        bestScore = newScore
      }
    }
    return bestScore
  }

  const bestScore = calculateBestScore(leaderboardData);
  const headingStr = leaderboardInfo?.heading || "N/A"
  const subHeadingStr = leaderboardInfo?.subHeading || ""
  const unitStr = leaderboardInfo?.unit || ""

  const dataBarList = leaderboardData.map((data, index) => {
    return (
      <>
        {
          index > 0 ? <Box sx={{ marginTop: 2, marginBottom: 2, width: '100%', background: '#ccc', height: '1px' }}></Box> : <></>
        }
        <LeaderboardItem key={`rand-${index}`}
          barData={data} bestScore={bestScore} unit={unitStr} />
      </>

    )
  }).slice(0, 5)

  // Ranking Bar Style  排行榜
  const barStyle = {
    background: "#FFE0C1",
    padding: "10px 50px",
    border: "8px solid #B96400",
    borderRadius: "20px",
    width: '90%',
    // marginTop: 3,
    // padding: 2,
    // background: 'rgba(0, 0, 0, 0.2)',
    // borderRadius: 2,
    // border: "2px solid white",
  }

  // console
  console.debug("dataBarList", dataBarList)

  
  return (
    <Box
      align="center"
      pt={2}
      minHeight={"100vh"}
      width={"100%"}
      sx={{
        backgroundImage: `url("${BackgroundMap[bgColor]
          }")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      position="relative"
    >
      <Grid
        container
        direction={"column"}
        justifyContent="center"
        alignItems={"center"}
        rowSpacing={2}
        pb={4}
        mb={4}
        sx={{
          // transform: "rotateY(12deg) rotateZ(-5deg) skewX(-5deg) ",
          // WebkitTransform: "rotateZ(-5deg) skewX(-5deg)" /* Safari & Chrome */,
          // MozTransform:
          //   "rotateY(12deg) rotateZ(-5deg) skewX(-5deg)" /* Firefox */,
          // MsTransform:
          //   "rotateY(12deg) rotateZ(-5deg) skewX(-5deg)" /* Internet Explorer */,
          // OTransform: "rotateY(12deg) rotateZ(-5deg) skewX(-5deg)" /* Opera */,
        }}
      >
        <Grid item xs={12} align={"center"}>
          <Grid item xs={12} align={"center"} sx={{ padding: 2 }}>
            <DisplayHeader heading={headingStr} subHeading={subHeadingStr} />
          </Grid>
        </Grid>

        {
          (isLoading == false && leaderboardData.length === 0) ? <NothingDisplay /> : <></>
        }
        {
          (isLoading) ?
            <Typography variant="h4" color={"black"}>
              資料載入中...
            </Typography>
            :
            <></> 
        }
        {/* <pre>
          isLoading: {isLoading ? "true" : "false"} <br />
          bestScore: {bestScore} <br />
          {JSON.stringify(leaderboardData, null, 2)}
          </pre> */}
        { /* Ranking Bar */}
        <Box sx={barStyle}>
          <Stack>
            {dataBarList}
          </Stack>
        </Box>

      </Grid >
    </Box >
  );
}
